import { Link } from "react-router-dom"
import './StartupLink.css'

type StartupLinkProps ={
    name:string,
    id:string,
    logoUrl:string
}

export const StartupLink = ({name, id , logoUrl }: StartupLinkProps)=>{

    return (

      <div className="w-100 p-0 m-0 mt-2 mb-2 startupLink-cont">
        <div className="m-0 p-0 d-flex flex-row h-100 align-items-center ">
            <div className="startup-img w-25 me-1 h-100">
                <img className="logo-cont" src={logoUrl} alt="logo startup" />
            </div>
            <div className="startup-info d-flex w-80 h-100  " style={{textDecoration:"none"}}>
               <h6 className=" m-0 p-0  ps-2" style={{textDecoration:"none"}}>{name}</h6>
            </div>
        </div>
        </div>

    )
}